var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvaluationManage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6875 2.25C1.6875 1.93934 1.93934 1.6875 2.25 1.6875H9.75C10.0607 1.6875 10.3125 1.93934 10.3125 2.25C10.3125 2.56066 10.0607 2.8125 9.75 2.8125H2.8125V15.1875H13.6875V9.75C13.6875 9.43934 13.9394 9.1875 14.25 9.1875C14.5607 9.1875 14.8125 9.43934 14.8125 9.75V15.75C14.8125 16.0607 14.5607 16.3125 14.25 16.3125H2.25C1.93934 16.3125 1.6875 16.0607 1.6875 15.75V2.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9375 2.8125C13.5588 2.19118 14.5662 2.19118 15.1875 2.8125V2.8125C15.8088 3.43382 15.8088 4.44118 15.1875 5.0625L9.99069 10.2593C9.71149 10.5385 9.35589 10.7288 8.96871 10.8063L7.04417 11.1912C6.90423 11.2192 6.78085 11.0958 6.80883 10.9558L7.19374 9.03129C7.27118 8.64411 7.46149 8.28851 7.74069 8.00931L12.9375 2.8125Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.375 3.375L14.625 5.625",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationManage);
export default __webpack_public_path__ + "static/media/evaluationManage.612f686b5f3410adbb28182ed111f989.svg";
export { ForwardRef as ReactComponent };